import React from 'react';
import {Link} from "react-router-dom";
import OImg from "../OImg";
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import {format} from "date-fns";
import {addSavedRoute, removeSavedRoute} from "../../actions";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import AlertUnlockComponent from "../AlertUnlockComponent";
import {useAuth} from "../../context/auth-context";
import {useUser} from "../../hooks/useUser";
import Constants from "../../config/constants";
import {getErrorsFromResponse} from "../../utils/helpers";
import {Alert, Box, Button, Container, Grid, Typography} from '@mui/material';
import FabRoute from "../FabRoute";
import WarningComponent from "../WarningComponent";
import TooltipComponent from "../TooltipComponent";
import {hasAllSectorSaved, hasUserStoreRouteBySlug} from "../../hooks/useRoute";
import RegionRoute from "../RegionRoute";
import OpenCloseWysiwigContent from "../OpenCloseWysiwigContent";
import {MuiButton} from "../MuiButton";
import useSEO from "../../hooks/useSEO";
import {getUrl, PWAUrls, PWAUrlsParams} from "../../config/urls";
import RouteAvatar from "./SearchComponent/RouteAvatar";
import GlobalFlashMessages from "../User/FlashMessages/FlashMessages";

const hasSectorMatch = (sector, matches) => {
    if (typeof matches !== 'object' || Array.isArray(matches) || matches === null) {
        return false;
    }

    if (matches.hasOwnProperty(sector.id)
        && matches[sector.id].split('*').length > 8) {
        return true;
    }

    return false;
}
const SecteurListComponent = ({t, i18n, falaise, saveRoute, savedRoutes, unsaveRoute, unlock, error, isOnline, searchQueryTerm}) => {
    const auth = useAuth();
    const email = auth?.user?.email ? auth.user.email : null;
    const {data, status: statusStoredRoutes} = useUser(email, i18n.language);
    const storedRoutes = Array.isArray(data?.user?.customerRoutes) ? data.user.customerRoutes : [];

    const hasAllSectorStored = hasAllSectorSaved(data?.user, falaise);

    const lastUpdateUi = falaise?.lastUpdateUi ? format(new Date(falaise.lastUpdateUi.slice(0, 10)), 'dd/MM/yyyy') : null;
    const presentationUrl = falaise?.presentation?.enabled ? getUrl(PWAUrls.PRESENTATION, {lng: i18n.language, slug: falaise?.presentation?.slug }): false;

    const seoTitleParams = {label: falaise.label, region: falaise.region.label };
    const seoDescriptionParams = {...seoTitleParams, routeCount: falaise.enabledSectors.length, grades: falaise.grades}

    const canonical = getUrl(PWAUrls.CLIFF, {lng: i18n.language, slugRegion: falaise.region.slug, slug: falaise.slug});
    useSEO({title: t("seo.title.cliff", seoTitleParams), description: t("seo.description.cliff", seoDescriptionParams)}, canonical);

    return (
        <Container maxWidth="md" className="secteurListContent" disableGutters={true}>
            <Grid container className="h-100 mt-0">
                {falaise.media?.url && <Grid item xs={12} lg={4}>
                    <OImg src={falaise.media.url}
                          wrapperClassName={'text-center'}
                          className={'adjust-width'}
                          alt={falaise.label}
                          height={falaise.media.height + 'px'}/>
                </Grid>}
                <Grid item xs={12} lg={falaise.media?.url ? 8 : 12}>
                    <Box sx={{ p: 1, }}>
                        <Box display="flex">
                            <Box flexGrow={1}>
                                <h2 className="my-2 text-tertiary">
                                    {falaise.label} {lastUpdateUi && <TooltipComponent title={t('SecteurListComponent.popover.last_update', {lastUpdateUi: lastUpdateUi})}
                                                                                       color="tertiary"
                                                                                       variant="text"
                                >
                                    <FontAwesomeIcon icon={['fa', 'fire']} size="sm" />
                                </TooltipComponent>}
                                </h2>

                            </Box>
                            <Box>
                                {falaise.presentation && <MuiButton component={Link}
                                                                 to={presentationUrl}
                                                                 variant="contained" color="primary"
                                >
                                    <FontAwesomeIcon icon={['fas', 'info-circle']} size="lg"/>
                                    &nbsp;{t('App.components.PresentationComponent.button')}
                                </MuiButton>}
                            </Box>
                        </Box>

                        {falaise?.region?.breadcrumb && <RegionRoute label={falaise?.region?.breadcrumb}
                                                                     className={falaise.avatarColor}
                        />}

                        {falaise.authorInfo && <Typography variant="body1" gutterBottom><b dangerouslySetInnerHTML={{__html:falaise.authorInfo}}/></Typography>}

                        <OpenCloseWysiwigContent description={falaise.description} descriptionShort={falaise.description_short} />
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Box sx={{ p: 1, }}>
                        <div className="float-left mr-2">
                            <dl className="dl-inline m-0 " style={{paddingTop: falaise.warning ? '34px' : 'inherit'}}>
                                {falaise.enabledSectors && falaise.enabledSectors.length > 0 && <React.Fragment>
                                    <dt>{t('SecteurListComponent.properties.label.sector_count')} </dt>
                                    <dd>{falaise.enabledSectors.length}</dd>
                                </React.Fragment>}
                                {falaise.approachTime && <React.Fragment>
                                    <dt>{t('SecteurListComponent.properties.label.approach_time')} </dt>
                                    <dd>{falaise.approachTime}</dd>
                                </React.Fragment>}
                                {falaise.rockTypeLabel && <React.Fragment>
                                    <dt>{t('SecteurListComponent.properties.label.rock_type')} </dt>
                                    <dd>{falaise.rockTypeLabel}</dd>
                                </React.Fragment>}
                                {(falaise.equipedBy_short || falaise.equipedBy) && <React.Fragment>
                                    <dt>{t('SecteurListComponent.properties.label.equiped_by')}</dt>
                                    <dd>
                                        <OpenCloseWysiwigContent description={falaise.equipedBy}
                                                                 descriptionShort={falaise.equipedBy_short}
                                                                 openCta={'\u00A0 +'}
                                                                 closeCta={'\u00A0 -'}
                                        />
                                    </dd>
                                </React.Fragment>}
                            </dl>
                        </div>
                        {falaise.warning && <div className="float-right mb-2">
                            <WarningComponent title={falaise.warning} />
                        </div>}
                    </Box>
                </Grid>

                {!unlock && <Grid item xs={12}>
                    <Box sx={{ p: 1, mb: 1}}>
                        <AlertUnlockComponent guidebooks={falaise.guidebookInfos}
                                              routeType={Constants.TypeTopo.FALAISE}
                                              product={falaise.product}
                        />
                    </Box>
                </Grid>}
            </Grid>

            {unlock && <Box sx={{ p: 1, mb: 1}}><GlobalFlashMessages regionIds={falaise?.regionDescendantIds}/></Box>}

            {falaise.enabledSectors && falaise.enabledSectors.length > 0 && <Grid item xs={12}>
                <table className="table table-striped table-hover table-sm table-layout-fixed">
                    <thead>
                    <tr className="table-secondary">
                        <th style={{width: "8%"}}>
                            <span className="d-inline-block d-lg-none">
                                <TooltipComponent title={t("Omegaroc.popover.last_update")}>
                                    <FontAwesomeIcon icon={['fa', 'fire']} />
                                </TooltipComponent>
                            </span>
                            <span
                                className="d-none d-lg-inline-block">{t('SecteurListComponent.thead.last_update')}</span>
                        </th>
                        <th style={{width: "45%"}}>{t('SecteurListComponent.thead.sector')}
                        </th>
                        <th style={{width: "12%"}}>
                            <span className="d-inline-block d-lg-none">
                                <TooltipComponent title={t('SecteurListComponent.popover.route_count')}>
                                    <span>{t('SecteurListComponent.thead.route_count_mobile')}</span>
                                </TooltipComponent>
                            </span>
                            <span
                                className="d-none d-lg-inline-block">{t('SecteurListComponent.thead.route_count')}</span>
                        </th>
                        <th style={{width: "12%"}}>
                            <span className="d-inline-block d-lg-none">
                                <TooltipComponent title={t('SecteurListComponent.popover.orientation')}>
                                    <span>{t('SecteurListComponent.thead.orientation_mobile')}</span>
                                </TooltipComponent>
                            </span>
                            <span
                                className="d-none d-lg-inline-block">{t('SecteurListComponent.thead.orientation')}</span>
                        </th>
                        <th style={{width: "12%"}}>
                            <span className="d-inline-block d-lg-none">
                                <TooltipComponent title={t('SecteurListComponent.popover.difficulty')}>
                                    <span>{t('SecteurListComponent.thead.difficulty_mobile')}</span>
                                </TooltipComponent>
                            </span>
                            <span
                                className="d-none d-lg-inline-block">{t('SecteurListComponent.thead.difficulty')}</span>
                        </th>
                        {unlock && <th style={{width: "8%"}}>
                            <span className="d-inline-block d-lg-none">
                                <FontAwesomeIcon icon={['fas', 'save']} />
                            </span>
                            <span
                                className="d-none d-lg-inline-block">{t('SecteurListComponent.thead.saved')}</span>
                        </th>}
                    </tr>
                    </thead>
                    <tbody>

                    {falaise.enabledSectors && falaise.enabledSectors.map((sector, index) => {
                        const isSaved = hasUserStoreRouteBySlug(data?.user, sector.slug);
                        const hasMatch = hasSectorMatch(sector, searchQueryTerm);

                        let lastUpdateUi = '';
                        if (typeof sector.lastUpdateUi !== 'undefined' && sector.lastUpdateUi) {
                            lastUpdateUi =  format(new Date(sector.lastUpdateUi.slice(0, 10)), 'dd/MM/yyyy');
                        }
                        return (
                            <tr key={index}>
                                <td>
                                    {lastUpdateUi && <TooltipComponent title={t('SecteurListComponent.popover.last_update', {lastUpdateUi: lastUpdateUi})}>
                                        <FontAwesomeIcon icon={['fa', 'fire']} />
                                    </TooltipComponent>}
                                </td>
                                <td style={{position: 'relative',}}>
                                    {hasMatch && <TooltipComponent title={t('SecteurListComponent.popover.matchQuery', /*{q: searchQueryTerm}*/)}>
                                        <FontAwesomeIcon icon={['fas', 'search']} className={'secondary'} />
                                    </TooltipComponent>}
                                    {/*{sector.label.length > 12 && <div className="scroll-x-container">*/}
                                    {/*    <div className="scroll-x-content">*/}
                                    {/*        <Link*/}
                                    {/*            to={window.location.pathname + '/' + sector.slug}>*/}
                                    {/*            <span className="react-link">{sector.label}</span>*/}
                                    {/*        </Link>*/}
                                    {/*    </div>*/}
                                    {/*</div>}*/}
                                    <Link
                                        style={{marginLeft: hasMatch ?'5px' : '0'}}
                                        to={window.location.pathname + '/' + sector.slug}>
                                        <span className={hasMatch ? "react-link secondary" : "react-link"}>{sector.label}</span>
                                    </Link>
                                    {falaise.avatarColor !== Constants.CLIFF && sector.enabledRouteCount > 0 && <div style={{position: 'absolute', top: '5px', right: '0px',}}>
                                        <RouteAvatar
                                            size="small"
                                            item={sector} />
                                    </div>}
                                </td>
                                <td>{sector.enabledRouteCount}</td>
                                <td>
                                        <span className="d-inline-block d-lg-none">
                                            {sector.orientation.split('/').length > 1 && <TooltipComponent title={sector.orientation_short}>
                                                <span>{t('Mult.')}</span>
                                            </TooltipComponent>}
                                            {sector.orientation.split('/').length === 1 &&
                                            <span>{sector.orientation_short}</span>
                                            }
                                        </span>
                                    <span
                                        className="d-none d-lg-inline-block">{sector.orientation}</span>
                                </td>
                                <td>{sector.difficulty}</td>
                                {unlock && <td>
                                    {isSaved && <span><FontAwesomeIcon icon={['fas', 'save']} /></span>}
                                </td>}
                            </tr>)
                    })}
                    </tbody>
                </table>

            </Grid>}

            <Box sx={{ p: 1, }}>
                <Grid container className="mb-3" spacing={1}>
                    {falaise.gmapsLink && <Grid item className="text-center" xs={falaise.hasApproachScreen ? 6 : 12} md={6}>
                         <Button target="_blank" href={falaise.gmapsLink}
                                  variant="contained" color="primary" fullWidth>{t('SecteurListComponent.approach.button.gmaps_link')}</Button>
                    </Grid>}
                    {falaise.hasApproachScreen && <Grid item className="text-center" xs={falaise.hasGmapsLink ? 6 : 12} md={6}>
                        {!unlock && <Button variant="contained" disabled={true} color="primary" fullWidth>{t('SecteurListComponent.tab.approach')}</Button>}

                        {unlock && <Button component={Link}
                                           to={window.location.pathname + '/' + PWAUrlsParams.approach[i18n.language]}
                                           variant="contained" color="primary" fullWidth>{t('SecteurListComponent.tab.approach')}</Button>}
                    </Grid>}

                    {error &&  <Grid item xs={12}>
                        <Alert
                            severity='error'
                            style={{marginTop: "15px", marginBottom: "15px"}}>
                            {getErrorsFromResponse(error.response).map((e, i) => {
                                return (<span key={i}>{e}<br/></span>);
                            })}
                        </Alert>
                    </Grid>}

                    <Grid item xs={12} md={6} className="mt-2">
                        {falaise.enabledSectors.length > 0 && <>
                            {hasAllSectorStored && unlock &&
                            <MuiButton onClick={unsaveRoute}
                                       disabled={statusStoredRoutes !== "success" || storedRoutes.length >= import.meta.env.VITE_MAX_STORAGE || !isOnline}
                                       variant="contained" color="secondary" fullWidth><FontAwesomeIcon icon={["fas", "save"]} className={"mr-2"} />
                                {t('SecteurComponent.button.saved')}
                            </MuiButton>}

                            {!hasAllSectorStored
                            && savedRoutes.length < import.meta.env.VITE_MAX_STORAGE
                            && unlock
                            && <MuiButton onClick={saveRoute}
                                          variant="contained" color="primary" fullWidth>
                                {t('SecteurComponent.button.save')}
                            </MuiButton>}
                        </>}
                    </Grid>
                </Grid>
            </Box>

            <FabRoute
                unlock={unlock}
                route={falaise}
                product={falaise.product}
                type={Constants.TypeTopo.FALAISE}
                />
        </Container>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        addSavedRoute: (route) => {
            dispatch(addSavedRoute(route))
        },
        removeSavedRoute: (route) => {
            dispatch(removeSavedRoute(route))
        },
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        searchQueryTerm: state.search.searchQueryTerm,
        savedRoutes: state.navbar.savedRoute,
        isOnline: state.common.isOnline,
    }
}


export default
    compose(
        withTranslation(),
        connect(
            mapStateToProps,
            mapDispatchToProps,
        ))(SecteurListComponent);